export const MONTHLY_PAYMENT_TABS = [
  { id: "charges", label: "Charges Summary", path: "charges-summary" },
  { id: "io", label: "IO Summary", path: "io-summary" },
  { id: "quilter", label: "Quilter Summary", path: "quilter-summary" },
  { id: "suspense", label: "Suspense", path: "suspense" },
  { id: "finplan", label: "Finplan", path: "finplan" },
  { id: "opening", label: "Opening Balances", path: "opening-balances" },
  { id: "closing", label: "Closing Balances", path: "closing-balances" },
  { id: "commission", label: "Commission Statements", path: "commission-statements" },
];
